<template>
  <generic-view
    class="column"
    :title="stage.name + ' - ' + stage.weighting_percent + '%'"
    icon="shoe prints"
    v-bind:show_plus="true"
    v-on:add="add_task(stage)"
    :header_buttons="header_buttons"
  >
    <div class="ui form">
      <div class="fields">
        <div class="eight wide field">
          <label for="">{{ $t("name") }}</label>
          <input type="text" name="" v-model="stage.name" />
        </div>
        <div class="five wide field">
          <label for="">{{ $t("weighting") }} (%)</label>
          <!-- <div class="ui labeled slider" :data-si="index"></div>
              <div class="ui input">
                <input type="text" id="slider-input-1" disabled="" />
              </div> -->
          <input type="text" name="" v-model="stage.weighting_percent" />
        </div>
        <div class="three wide field">
          <label>{{ $t("extra") }}</label>
          <div class="ui toggle checkbox">
            <input type="checkbox" name="example" v-model="stage.extra" />
            <label></label>
          </div>
        </div>
      </div>
    </div>
    <h4 class="ui dividing header">{{ $t("activities") }}</h4>
    <div
      class="ui error message"
      style="display: inline-block"
      v-if="task_weighting_summation(stage) > 100"
    >
      <div class="header">
        {{ $t("limit overflow") }}
      </div>
      <p>
        {{ $t("weighting summation is above limit, check tasks weighting") }}
      </p>
    </div>
    <div class="ui form">
      <div class="fields" v-for="(task, idx) in stage.tasks" :key="idx">
        <div class="nine wide field">
          <label for="" v-if="idx == 0">{{ $t("name") }}</label>
          <input type="text" name="" v-model="stage.tasks[idx].name" />
        </div>
        <div class="five wide field">
          <label for="" v-if="idx == 0">{{ $t("weighting") }} (%)</label>
          <input
            type="text"
            name=""
            v-model="stage.tasks[idx].weighting_percent"
          />
        </div>
        <div class="two wide field">
          <label for="" v-if="idx == 0">{{ $t("delete") }}</label>
          <div class="ui mini icon red button" @click="remove_task(idx)">
            <i class="trash icon"></i>
          </div>
        </div>
      </div>
    </div>
    <div
      class="ui info message"
      style="display: inline-block"
      v-if="task_weighting_summation(stage) < 100"
    >
      <div class="header">
        {{ $t("weighting incomplete") }}
      </div>
      <p>
        {{ $t("weighting summation is incomplete, check tasks weighting") }}
      </p>
    </div>
  </generic-view>
</template>

<script>
import GenericView from "@/components/GenericContainer";

export default {
  name: "",
  props: { stage: Object, index: Number },
  components: { GenericView },
  data() {
    return {
      header_buttons: [
        {
          icon: "red trash",
          click: this.remove_stage,
        },
      ],
    };
  },
  methods: {
    task_weighting_summation(stage) {
      return stage.tasks.reduce((prev, curr) => {
        return prev + Number(curr.weighting_percent);
      }, 0);
    },
    remove_stage() {
      this.$emit("remove_stage", this.index);
    },
    add_task(stage) {
      console.log("stage", stage);
      let vm = this;
      if (!stage.tasks) stage.tasks = [];
      stage.tasks.push({
        name: vm.$t("task") + stage.tasks.length,
        weighting_percent: 0,
      });
    },
    remove_task(idx) {
      this.stage.tasks.splice(idx, 1);
    },
  },
};
</script>
